import pullAll from 'lodash/pullAll';
import values from 'lodash/values';
import { createReducer } from '../utils/reducers';
import {
    LOGIN_USER_REQUEST,
    LOGIN_USER_SUCCESS,
    LOGIN_USER_FAILURE,
    REGISTER_USER_REQUEST,
    REGISTER_USER_SUCCESS,
    REGISTER_USER_FAILURE,
    USER_REQUEST,
    USER_SUCCESS,
    USER_FAILURE,
    LOGOUT_USER_REQUEST,
    LOGOUT_USER_SUCCESS,
    LOGOUT_USER_FAILURE,
    CHANGE_PASSWORD_REQUEST,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAILURE,
    UPDATE_USER_REQUEST,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_FAILURE,
    GET_SOCIAL_REQUEST,
    GET_SOCIAL_SUCCESS,
    GET_SOCIAL_FAILURE,
    GET_REGISTER_REQUEST,
    GET_REGISTER_SUCCESS,
    GET_REGISTER_FAILURE,
    GET_PURCHASE_HISTORY_SUCCESS,
    SET_LANGUAGE,
    CHANGE_ACCESS_STATUS,
    EXPORT_DATA_REQUEST,
    EXPORT_DATA_SUCCESS,
    EXPORT_DATA_FAILURE,
    RESET_EXPORT_MESSAGE,
    SET_PASSWORD_SUCCESS,
    SET_PASSWORD_REQUEST,
    SET_PASSWORD_FAILURE,
    UPDATE_ACCOUNT_SUCCESS,
    UPDATE_ACCOUNT_REQUEST,
    UPDATE_ACCOUNT_FAILURE,
    DELETE_ACCOUNT_SUCCESS,
    DELETE_ACCOUNT_REQUEST,
    DELETE_ACCOUNT_FAILURE,
} from '../actions/user';
import { SETUP_PAYWALL } from '../actions/paywall';

import tokenManager from '../utils/token';
import InPlayer from '@inplayer-org/inplayer.js';

const INITIAL_STATE = {
    user: undefined,
    token: '',
    isAuthenticating: false,
    isLoading: false,
    isAuthenticated: false,
    isRegistered: false,
    isRegistering: false,
    isUpdating: false,
    isFetchingSocial: false,
    socialUrls: [],
    isFetchingRegister: false,
    registerFields: null,
    isSplitUp: false,
    purchase_history: {
        collection: [],
        total: 0,
        status: 'active',
    },
    pendingRefreshingToken: false,
    language: 'en',
    isDataExported: false,
    isDataExportedError: false,
    isLoadingButton: false,
};

export default createReducer(INITIAL_STATE, {
    [SETUP_PAYWALL]: (state, action) => {
        return {
            ...state,
            language: action.data.options.language
                ? action.data.options.language.toLowerCase()
                : 'en',
        };
    },
    [LOGIN_USER_REQUEST]: state => {
        return {
            ...state,
            isAuthenticating: true,
            isLoadingButton: true,
        };
    },
    [LOGIN_USER_SUCCESS]: (state, action) => {
        return {
            ...state,
            isAuthenticated: true,
            isAuthenticating: false,
            isRegistered: true,
            isLoadingButton: false,
            token: action.data.access_token,
            user: action.data.account,
        };
    },
    [LOGIN_USER_FAILURE]: (state, action) => {
        return {
            ...state,
            loginErrorMsg: action.data.message,
            isLoadingButton: false,
        };
    },
    [REGISTER_USER_SUCCESS]: (state, action) => {
        return {
            ...state,
            isAuthenticated: true,
            isRegistered: true,
            isRegistering: false,
            isAuthenticating: false,
            token: action.data.access_token,
            user: action.data.account,
            isLoadingButton: false,
        };
    },
    [REGISTER_USER_REQUEST]: state => {
        return {
            ...state,
            isRegistering: true,
            isLoadingButton: true,
        };
    },
    [REGISTER_USER_FAILURE]: state => {
        return {
            ...state,
            isRegistered: false,
            isRegistering: false,
            isLoadingButton: false,
        };
    },
    [USER_REQUEST]: state => {
        return {
            ...state,
            isLoading: true,
        };
    },
    [USER_SUCCESS]: (state, action) => {
        return {
            ...state,
            isAuthenticated: true,
            isAuthenticating: false,
            isLoading: false,
            token: InPlayer.Account.getToken().token,
            user: action.data,
        };
    },
    [USER_FAILURE]: () => {
        tokenManager.clear();
        return INITIAL_STATE;
    },
    [LOGOUT_USER_REQUEST]: (state, action) => {
        return {
            ...INITIAL_STATE,
            language: state.language,
        };
    },
    [LOGOUT_USER_SUCCESS]: (state, action) => {
        return {
            ...INITIAL_STATE,
            language: state.language,
        };
    },
    [LOGOUT_USER_FAILURE]: (state, action) => {
        return {
            ...INITIAL_STATE,
            language: state.language,
        };
    },
    [CHANGE_PASSWORD_REQUEST]: state => {
        return {
            ...state,
            isUpdating: true,
            isLoadingButton: true,
        };
    },
    [CHANGE_PASSWORD_SUCCESS]: (state, action) => {
        return {
            ...state,
            isUpdating: false,
            isLoadingButton: false,
        };
    },
    [CHANGE_PASSWORD_FAILURE]: (state, action) => {
        const errors = action.payload.errors;
        return {
            ...state,
            isUpdating: false,
            isLoadingButton: false,
        };
    },
    [UPDATE_USER_REQUEST]: state => {
        return {
            ...state,
            isUpdating: true,
        };
    },
    [UPDATE_USER_SUCCESS]: (state, action) => {
        return {
            ...state,
            isUpdating: false,
            user: {
                ...state.user,
                metadata: action.meta.data,
            },
        };
    },
    [UPDATE_USER_FAILURE]: state => {
        return {
            ...state,
            isUpdating: false,
        };
    },
    [GET_SOCIAL_REQUEST]: state => {
        return {
            ...state,
            isFetchingSocial: true,
            isSocialFetched: false,
        };
    },
    [GET_SOCIAL_SUCCESS]: (state, action) => {
        return {
            ...state,
            socialUrls: [...action.payload],
            isFetchingSocial: false,
            isSocialFetched: true,
        };
    },
    [GET_SOCIAL_FAILURE]: state => {
        return {
            ...state,
            isFetchingSocial: false,
            isSocialFetched: true,
        };
    },
    [GET_REGISTER_REQUEST]: state => {
        return {
            ...state,
            isFetchingRegister: true,
            isSplitUp: false,
            isRegisterFetched: false,
        };
    },
    [GET_REGISTER_SUCCESS]: (state, action) => {
        let startCollection = [...action.payload.collection];

        let newCollection = [];
        startCollection.forEach(item => {
            if (item.name === 'first_name') newCollection.splice(0, 0, item);
            if (item.name === 'surname') newCollection.splice(1, 0, item);
        });

        pullAll(startCollection, newCollection);

        return {
            ...state,
            registerFields: [...newCollection, ...startCollection],
            isSplitUp: newCollection.length !== 0,
            isFetchingRegister: false,
            isRegisterFetched: true,
        };
    },
    [GET_REGISTER_FAILURE]: state => {
        return {
            ...state,
            isFetchingSocial: false,
            isSplitUp: false,
            isFetchingRegister: false,
            isRegisterFetched: false,
        };
    },
    [GET_PURCHASE_HISTORY_SUCCESS]: (state, action) => {
        let newHistory = [];
        if (
            action.payload.isInitial ||
            action.payload.status !== state.purchase_history.status
        )
            newHistory = action.payload.data.collection;
        else
            newHistory = state.purchase_history.collection.concat(
                action.payload.data.collection
            );

        return {
            ...state,
            purchase_history: {
                collection: [...newHistory],
                total: action.payload.data.total,
                status: action.payload.status,
                page: action.payload.page,
            },
        };
    },
    [SET_LANGUAGE]: (state, action) => {
        return {
            ...state,
            language: action.language,
        };
    },
    [CHANGE_ACCESS_STATUS]: (state, action) => {
        return {
            ...state,
            purchase_history: {
                ...state.purchase_history,
                status: action.status,
            },
        };
    },
    ['REFRESHING_TOKEN']: (state, action) => {
        return {
            ...state,
            pendingRefreshingToken: true,
        };
    },
    ['REFRESHING_TOKEN_SUCCESS']: state => {
        return {
            ...state,
            pendingRefreshingToken: false,
        };
    },
    [EXPORT_DATA_REQUEST]: state => {
        return {
            ...state,
            isLoadingButton: true,
        };
    },
    [EXPORT_DATA_SUCCESS]: state => {
        return {
            ...state,
            isDataExported: true,
            isLoadingButton: false,
        };
    },
    [EXPORT_DATA_FAILURE]: state => {
        return {
            ...state,
            isDataExportedError: true,
            isLoadingButton: false,
        };
    },
    [RESET_EXPORT_MESSAGE]: state => {
        return {
            ...state,
            isDataExported: false,
        };
    },
    [SET_PASSWORD_SUCCESS]: (state, action) => {
        return {
            ...state,
            setPassSuccMsg: action.data.message,
            isLoadingButton: false,
        };
    },
    [SET_PASSWORD_REQUEST]: (state, action) => {
        return {
            ...state,
            isLoadingButton: true,
        };
    },
    [SET_PASSWORD_FAILURE]: (state, action) => {
        return {
            ...state,
            setPassErrorMsg: values(action.data.errors)[0],
            isLoadingButton: false,
        };
    },
    [UPDATE_ACCOUNT_SUCCESS]: (state, action) => {
        return {
            ...state,
            user: action.payload,
            isLoadingButton: false,
        };
    },
    [UPDATE_ACCOUNT_REQUEST]: (state, action) => {
        return {
            ...state,
            isLoadingButton: true,
        };
    },
    [UPDATE_ACCOUNT_FAILURE]: (state, action) => {
        return {
            ...state,
            isLoadingButton: false,
        };
    },
    [DELETE_ACCOUNT_SUCCESS]: (state, action) => {
        return {
            ...state,
            user: action.payload,
            isLoadingButton: false,
        };
    },
    [DELETE_ACCOUNT_REQUEST]: (state, action) => {
        return {
            ...state,
            isLoadingButton: true,
        };
    },
    [DELETE_ACCOUNT_FAILURE]: (state, action) => {
        return {
            ...state,
            isLoadingButton: false,
        };
    },
});



// WEBPACK FOOTER //
// ./src/reducers/auth.js